import React, { useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { AppProvider } from './context/AppContext';
import { startDriverLogger, logEvent } from './utils/driverLogger';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import Header from './components/Header';
import Footer from './components/Footer';

import VendorAccess from './pages/vendor/access'; 
import Home from './pages/delivery/home/index';
import PickUp from './pages/delivery/pickup/pick-up';
import UploadWeightTicket from './pages/delivery/upload-weight-ticket/uploadWeightTicket'; 
import Jobsite from './pages/delivery/jobsite/jobsite';
import UploadDumpMatericalPhoto from './pages/delivery/proof-of-dump-material/proofOfDumpMaterial';
import UploadProofOfDumping from './pages/delivery/proof-of-dumping/UploadProofOfDumping';
import DigitalSignature from './pages/delivery/signature/DigitalSignature';
import DumpSitePhotoReason from './pages/delivery/photo-reason/DumpSitePhotoReason';
import NoanotherDelivery from './pages/delivery/no-another/NoanotherDelivery';
import CompleteDelivery from './pages/delivery/complete/CompleteDelivery';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';
import VerifyPurchaseOrder from './pages/vendor/VerifyPurchaseOrder';
import DriverAccess from './pages/vendor/driver-access';
import JobCompleted from './pages/job-completed/JobCompleted';
 
// import AnotherDelivery from './pages/delivery/another/AnotherDelivery';

 
// Wrapper component to handle driver-access with or without token
function DriverAccessWrapper() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  
  // If token is provided, use VendorAccess (token-based flow)
  // Otherwise, show DriverAccess form (SO number + PIN)
  return token ? <VendorAccess /> : <DriverAccess />;
}

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    logEvent('route_change', {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  // Check if we are on a standalone page
  const isStandalone =
    location.pathname === '/403' ||
    location.pathname === '/404' ||
    location.pathname === '/job-completed' ||
    location.pathname === '/driver-access' ||
    location.pathname.startsWith('/verify-po/');

  return (
    <>
      {!isStandalone && <Header />}
      <div className="App"> 
        <Routes>
          <Route path="/driver-access" element={<DriverAccessWrapper />} />
          <Route path="/verify-po/:token" element={<VerifyPurchaseOrder />} />
          <Route path="/" element={<Home />} />
          <Route path="/pick-up" element={<PickUp />} />
          <Route path="/upload-weight-ticket" element={<UploadWeightTicket />} />
          <Route path="/jobsite" element={<Jobsite />} />
          <Route path="/proof-of-dump-meterial" element={<UploadDumpMatericalPhoto />} />
          {/* <Route path="/proof-of-dumping" element={<UploadProofOfDumping />} /> */}
          {/* <Route path="/another-delivery" element={<AnotherDelivery />} /> */}
          <Route path="/dump-site-photo-reason" element={<DumpSitePhotoReason />} />
          <Route path="/digital-signature" element={<DigitalSignature />} />
          <Route path="/complete-delivery" element={<CompleteDelivery />} />
          <Route path="/no-another-delivery" element={<NoanotherDelivery />} />
          <Route path="/job-completed" element={<JobCompleted />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isStandalone && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    startDriverLogger();
  }, []);

  return (
    <AppProvider>
      <Router>
        <AppContent />
      </Router>
    </AppProvider>
  );
}

export default App;
